import "./index.css";
import { MaintenanceScreen } from "./components/Maintenance";
import { Nav } from "./components/Nav";
import { RosterDrawer } from "./components/RosterDrawer";
import { MAINTENANCE } from "./lib/config";
import { RouterProvider, useRouter } from "./lib/router";
import { AppProvider, useApp } from "./lib/store";
import { DebugPage } from "./pages/DebugPage";
import { EventPage } from "./pages/EventPage";
import { Home } from "./pages/Home";
import { WindowPage } from "./pages/WindowPage";

export function App() {
  // While the backend is down for infra work, take over the whole screen — the
  // live app can't function without it, so there's nothing to wrap a banner
  // around. Rendered before the providers: it depends on neither.
  if (MAINTENANCE) return <MaintenanceScreen />;

  return (
    <RouterProvider>
      <AppProvider>
        <div className="flex min-h-screen flex-col">
          <Nav />
          <div className="flex-1">
            <Routes />
          </div>
          <Footer />
        </div>
        <RosterDrawer />
      </AppProvider>
    </RouterProvider>
  );
}

function Routes() {
  const { path } = useRouter();

  if (path.startsWith("/event/")) {
    const baseId = decodeURIComponent(path.slice("/event/".length));
    return <EventPage baseId={baseId} />;
  }
  if (path.startsWith("/window/")) {
    const rest = path.slice("/window/".length);
    if (rest.endsWith("/debug")) {
      const windowId = decodeURIComponent(rest.slice(0, -"/debug".length));
      return <DebugPage windowId={windowId} />;
    }
    return <WindowPage windowId={decodeURIComponent(rest)} />;
  }
  return <Home />;
}

function Footer() {
  const { offline } = useApp();
  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-6 py-8">
        <p className="text-xs text-faint">
          watch<span className="text-accent">.</span>party — the fastest match finder
        </p>
        <div className="flex items-center gap-3">
          <span
            className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[11px] ${
              offline ? "border-err/40 text-err" : "border-border text-dim"
            }`}
          >
            <span className={`h-1.5 w-1.5 rounded-full ${offline ? "bg-err" : "bg-ok"}`} />
            {offline ? "offline" : "connected"}
          </span>
          <p className="font-mono text-[10.5px] text-faint">not affiliated with Epic</p>
        </div>
      </div>
    </footer>
  );
}

export default App;
